import React from "react";
import TeamGroup from "../../components/TeamAuthorization/TeamGroup";
import TeamToggler from "../../components/TeamAuthorization/TeamToggler";

import TeamAuthorizationDTO from "../../dtos/TeamAuthorizationDTO";
import { TeamAuthorizationProvider } from "../../components/TeamAuthorization/TeamAuthorizationContext";
import { generateKey } from "../../utils/generateKey";
import { parametarExtractor } from "../../utils/parametarExtractor";

const TeamAuthorization = (props) => {
    const dataPathAttribute = props.dataPath.replace(/\//g, "");
    const componentDataRaw = props.data[dataPathAttribute];
    const componentData = new TeamAuthorizationDTO(componentDataRaw).data;
    const resourceKey = props.router.route.options.resourceKey;
    const clubId = props.data.id;
    const locale = props.router.attributes?.locale || "de";

    const params = parametarExtractor(props);

    const contextValue = {
        resourceKey,
        clubID: clubId,
        locale,
        optionsParams: params,
    };

    return (
        <TeamAuthorizationProvider value={contextValue}>
            <div>
                <TeamToggler />
                {componentData &&
                    Object.keys(componentData).map((category, index) => {
                        const key = generateKey(index);
                        return (
                            <TeamGroup
                                key={key}
                                category={category}
                                data={componentData[category]}
                            />
                        );
                    })}
            </div>
        </TeamAuthorizationProvider>
    );
};

export default TeamAuthorization;
